import { render } from "./ParametersList.vue?vue&type=template&id=310ccd44"
import script from "./ParametersList.vue?vue&type=script&lang=js"
export * from "./ParametersList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\JOGA\\Desktop\\Projekty\\Trash3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__